import { Routes } from '@angular/router';
import { LoginSmsPageComponent } from './containers/login-sms-page.component';
import { LoginEmailPageComponent } from './containers/login-email-page.component';


export const routesLogin: Routes = [
  {path: 'email', component: LoginEmailPageComponent},
  {path: 'sms', component: LoginSmsPageComponent},
];





// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/login.routes.ts